import type { SVGProps } from 'react';

const SvgNoCodingRequired = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="no-coding-required">
      <path d="M3 26.13h13.13v-1.5H3a1.21 1.21 0 0 1-1.2-1.21V3.25A1.21 1.21 0 0 1 3 2h19.88a1.21 1.21 0 0 1 1.21 1.21v12.67h1.5V3.25A2.71 2.71 0 0 0 22.88.54H3A2.71 2.71 0 0 0 .32 3.25v20.17A2.71 2.71 0 0 0 3 26.13Z" />
      <path d="M24.56 17.15a7.16 7.16 0 1 0 7.15 7.15 7.15 7.15 0 0 0-7.15-7.15Zm-5.65 7.15a5.65 5.65 0 0 1 5.65-5.65 5.59 5.59 0 0 1 3.52 1.24l-7.94 7.93a5.62 5.62 0 0 1-1.23-3.52Zm5.65 5.7a5.57 5.57 0 0 1-3.33-1.1l7.89-7.9a5.65 5.65 0 0 1-4.56 9ZM7.72 6.43 4.05 10.1a.75.75 0 0 0 0 1.06l3.67 3.66 1.06-1.06-3.14-3.13 3.14-3.14ZM18.2 14.82l3.67-3.66a.75.75 0 0 0 0-1.06L18.2 6.43l-1.06 1.06 3.14 3.14-3.14 3.13ZM10.87 16.583l2.71-11.956 1.462.331-2.71 11.957z" />
    </g>
  </svg>
);

export default SvgNoCodingRequired;
